export class AccountConstraints {
  public static Username = {
    MinLength: 2,
    MaxLength: 128,
  };
  public static Email = {
    MaxLength: 256,
  };
  public static FullName = {
    MaxLength: 128,
  };
  public static Password = {
    MinLength: 12,
    MaxLength: 128,
  };
}
